import React, { useState } from 'react';
import { XIcon, Save, UserPlusIcon } from 'lucide-react';
import { useUser } from '../context/UserContext';
interface UserManagementProps {
  onClose: () => void;
}
interface EditUserDialogProps {
  user: {
    id: number;
    username: string;
    password: string;
    isAdmin: boolean;
    moduleAccess: {
      production: boolean;
      laboratory: boolean;
      disposition: boolean;
    };
  };
  onClose: () => void;
  onSave: (user: any) => void;
}
const DEFAULT_NEW_USER = {
  username: '',
  password: '',
  isAdmin: false,
  moduleAccess: {
    production: false,
    laboratory: false,
    disposition: false
  }
};
function EditUserDialog({
  user,
  onClose,
  onSave
}: EditUserDialogProps) {
  const [editedUser, setEditedUser] = useState({
    ...user
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(editedUser);
  };
  return <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50" data-id="element-1232">
      <div className="bg-white rounded-lg p-6 w-[500px] max-w-full" data-id="element-1233">
        <div className="flex justify-between items-center mb-4" data-id="element-1234">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-1235">
            Benutzer bearbeiten
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-1236">
            <XIcon size={20} data-id="element-1237" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1238">
          <div data-id="element-1239">
            <label className="block text-sm text-gray-700 mb-1" data-id="element-1240">
              Benutzername
            </label>
            <input type="text" value={editedUser.username} onChange={e => setEditedUser({
            ...editedUser,
            username: e.target.value
          })} className="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:border-[#3498dd]" data-id="element-1241" />
          </div>
          <div data-id="element-1242">
            <label className="block text-sm text-gray-700 mb-1" data-id="element-1243">Passwort</label>
            <input type="password" value={editedUser.password} onChange={e => setEditedUser({
            ...editedUser,
            password: e.target.value
          })} className="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:border-[#3498dd]" data-id="element-1244" />
          </div>
          <div data-id="element-1245">
            <label className="block text-sm text-gray-700 mb-2" data-id="element-1246">
              Modul-Zugriff
            </label>
            <div className="space-y-2" data-id="element-1247">
              <label className="flex items-center" data-id="element-1248">
                <input type="checkbox" checked={editedUser.moduleAccess.production} onChange={e => setEditedUser({
                ...editedUser,
                moduleAccess: {
                  ...editedUser.moduleAccess,
                  production: e.target.checked
                }
              })} className="mr-2" data-id="element-1249" />
                <span className="text-sm text-gray-700" data-id="element-1250">Produktion</span>
              </label>
              <label className="flex items-center" data-id="element-1251">
                <input type="checkbox" checked={editedUser.moduleAccess.laboratory} onChange={e => setEditedUser({
                ...editedUser,
                moduleAccess: {
                  ...editedUser.moduleAccess,
                  laboratory: e.target.checked
                }
              })} className="mr-2" data-id="element-1252" />
                <span className="text-sm text-gray-700" data-id="element-1253">Labor</span>
              </label>
              <label className="flex items-center" data-id="element-1254">
                <input type="checkbox" checked={editedUser.moduleAccess.disposition} onChange={e => setEditedUser({
                ...editedUser,
                moduleAccess: {
                  ...editedUser.moduleAccess,
                  disposition: e.target.checked
                }
              })} className="mr-2" data-id="element-1255" />
                <span className="text-sm text-gray-700" data-id="element-1256">Disposition</span>
              </label>
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-1257">
            <input type="checkbox" checked={editedUser.isAdmin} onChange={e => setEditedUser({
            ...editedUser,
            isAdmin: e.target.checked
          })} className="mr-2" data-id="element-1258" />
            <span className="text-sm text-gray-700" data-id="element-1259">Administrator</span>
          </div>
          <div className="flex justify-end gap-2 pt-4" data-id="element-1260">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded" data-id="element-1261">
              Abbrechen
            </button>
            <button type="submit" className="px-4 py-2 text-sm text-white bg-[#3498dd] hover:bg-blue-600 rounded flex items-center" data-id="element-1262">
              <Save size={16} className="mr-2" data-id="element-1263" />
              Speichern
            </button>
          </div>
        </form>
      </div>
    </div>;
}
export function UserManagement({
  onClose
}: UserManagementProps) {
  const {
    users,
    updateUser,
    createUser
  } = useUser();
  const [editingUser, setEditingUser] = useState<any | null>(null);
  const [isCreating, setIsCreating] = useState(false);
  const handleSaveUser = (updatedUser: any) => {
    if ('id' in updatedUser) {
      updateUser(updatedUser);
    } else {
      createUser(updatedUser);
    }
    setEditingUser(null);
    setIsCreating(false);
  };
  const handleCreateNew = () => {
    setIsCreating(true);
    setEditingUser(DEFAULT_NEW_USER);
  };
  return <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50" data-id="element-1264">
      <div className="bg-white rounded-lg p-6 w-[800px] max-w-full" data-id="element-1265">
        <div className="flex justify-between items-center mb-4" data-id="element-1266">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-1267">
            Benutzerverwaltung
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-1268">
            <XIcon size={20} data-id="element-1269" />
          </button>
        </div>
        <div className="mb-4" data-id="element-1270">
          <button onClick={handleCreateNew} className="flex items-center gap-1 bg-[#3498dd] text-white px-3 py-1.5 rounded text-sm hover:bg-blue-600" data-id="element-1271">
            <UserPlusIcon size={16} data-id="element-1272" />
            Neuer Benutzer
          </button>
        </div>
        <div className="overflow-x-auto" data-id="element-1273">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-1274">
            <thead data-id="element-1275">
              <tr className="text-xs text-gray-500" data-id="element-1276">
                <th className="px-4 py-2 text-left" data-id="element-1277">Benutzername</th>
                <th className="px-4 py-2 text-left" data-id="element-1278">Rolle</th>
                <th className="px-4 py-2 text-left" data-id="element-1279">Module</th>
                <th className="px-4 py-2 text-left" data-id="element-1280">Aktionen</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-1281">
              {users.map(user => <tr key={user.id} className="text-sm" data-id="element-1282">
                  <td className="px-4 py-3 text-gray-800" data-id="element-1283">{user.username}</td>
                  <td className="px-4 py-3 text-gray-600" data-id="element-1284">
                    {user.isAdmin ? 'Administrator' : 'Benutzer'}
                  </td>
                  <td className="px-4 py-3" data-id="element-1285">
                    <div className="flex gap-1" data-id="element-1286">
                      {user.moduleAccess.production && <span className="px-2 py-0.5 bg-blue-50 text-blue-700 rounded-full text-xs" data-id="element-1287">
                          Produktion
                        </span>}
                      {user.moduleAccess.laboratory && <span className="px-2 py-0.5 bg-green-50 text-green-700 rounded-full text-xs" data-id="element-1288">
                          Labor
                        </span>}
                      {user.moduleAccess.disposition && <span className="px-2 py-0.5 bg-purple-50 text-purple-700 rounded-full text-xs" data-id="element-1289">
                          Disposition
                        </span>}
                    </div>
                  </td>
                  <td className="px-4 py-3" data-id="element-1290">
                    <button onClick={() => {
                  setIsCreating(false);
                  setEditingUser(user);
                }} className="text-xs text-[#3498dd] hover:text-blue-600" data-id="element-1291">
                      Bearbeiten
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      {editingUser && <EditUserDialog user={editingUser} onClose={() => {
      setEditingUser(null);
      setIsCreating(false);
    }} onSave={handleSaveUser} data-id="element-1292" />}
    </div>;
}